import { Host } from './Host';
import { HostImageStack } from './HostImageStack';
import { Typography } from '@eventbrite/marmalade';
import styles from './Hosts.module.scss';

export const Hosts: React.FC<{ hosts?: Host[] }> = ({ hosts }) => {
  if (!hosts || hosts.length === 0) {
    return null;
  }

  return (
    <div className={styles.host}>
      <HostImageStack hosts={hosts} />
      <Typography className={styles.name} as="span" variant="body-sm">
        {hosts.map((host) => host.name).join(', ')}
      </Typography>
    </div>
  );
};
